import React from 'react';
import Button from '../ui/Button.jsx';
import { _t } from '../../utils/i18n.js';

/** Shown by App.js when the lazy PULSE chunk fails to load (offline, or a deploy replaced it). */
const PulseLoadError = () => (
  <div role="alert" className="mx-auto flex max-w-md flex-col items-center gap-4 px-4 py-16 text-center">
    <p className="text-gray-700 dark:text-gray-300">{_t('PULSE could not be loaded.')}</p>
    <Button onClick={() => window.location.reload()}>{_t('Reload the page')}</Button>
  </div>
);

export default PulseLoadError;
